import React from 'react'
import './Cart.css'
import Cartitems from './Cartitems'
import Product from './Product'
import { useStateValue } from './State'
import Subtotal from './Subtotal'
function Cart() {
    const [{cart},dispatch]=useStateValue();
    return (
        <div className="cart">
            <div className="left">
                <div>
                    <h2 className="cart_title">Items in Cart</h2>
                    
                    {cart.map(i=>{
                        return (
                        <Cartitems
                        title={i.title}
                        price={i.price}
                        img_url={i.img_url}
                        rating={i.rating} />
                        )
                       })}
                      
                     
                    
                    
                      
                    
                </div>
            </div>
            <div className="right">
                
                <Subtotal/>
                
            </div>
        </div>
    )
}

export default Cart
